// @flow

import invariant                                            from 'invariant';
import type {
  Dispatch,
  Middleware,
  MiddlewareAPI,
}                                                           from 'redux';
import type { State }                                       from '../../../../store';
import { getConfig }                                        from '../../config';
import clearPersonalContent                                 from '../actions/clearPersonalContent';
import type { DisplayPersonalisedDataClearedMessageAction } from '../actions/displayPersonalisedDataClearedMessage';
import displayPersonalisedDataClearedMessage                from '../actions/displayPersonalisedDataClearedMessage';
import type { IsPersonalisedAction }                        from '../actions/isPersonalised';
import isPersonalised                                       from '../actions/isPersonalised';
import { selectIsPersonalised }                             from '../selectors';
import compareUpdatedStateWithBase                          from '../utils/compareUpdatedStateWithBase';
import preparePublicPathTree                                from '../utils/preparePublicPathTree';

/**
 * Generics
 *
 * S = State
 * A = Action
 * R = Result
 */


// -----------------------------------------------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------------------------------------------


// -----------------------------------------------------------------------------------------------------------------
// Middleware
// -----------------------------------------------------------------------------------------------------------------

/**
 * @param {MiddlewareAPI<State, IsPersonalisedAction>} store
 *
 * @return {function(<IsPersonalisedAction>): Function}
 *
 * @todo $FlowFixMe
 */
const personalContentMiddleware: Middleware<State, IsPersonalisedAction> = (store: MiddlewareAPI<State, IsPersonalisedAction | DisplayPersonalisedDataClearedMessageAction>) => {

  const baseState = getConfig().baseState;

  invariant(baseState, 'baseState cannot be found');

  return function (next: Dispatch<IsPersonalisedAction>) {

    return function (action) {

      const initialState = store.getState();

      // Update state
      // ------------

      const result = next(action);

      // Display messages after clearing personal content
      // ------------------------------------------------

      if (String(clearPersonalContent) === action.type) {
        store.dispatch(displayPersonalisedDataClearedMessage());
      }

      // Check for personal changes
      // --------------------------

      const updatedState = store.getState();

      if (updatedState === initialState) {
        return result;
      }

      if (selectIsPersonalised(updatedState)) {
        return result;
      }

      if (getConfig().ignoreActions.indexOf(action.type) !== -1) {
        return result;
      }

      const changes = compareUpdatedStateWithBase(updatedState, baseState, preparePublicPathTree());

      if (changes.length) {
        store.dispatch(isPersonalised({causedBy: changes, config: getConfig()}));
      }

      return result;

    };

  };

};


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default personalContentMiddleware;



// WEBPACK FOOTER //
// ./src/modules/personalContent/store/middleware/personalContentMiddleware.js